export default function getDataAttributes(element) {
  const data = JSON.parse(element.getAttribute("data-prop"));
  return data;
}
